import { render, staticRenderFns } from "./PayPalIntegration.vue?vue&type=template&id=db2f7076&scoped=true&"
import script from "./PayPalIntegration.vue?vue&type=script&lang=ts&"
export * from "./PayPalIntegration.vue?vue&type=script&lang=ts&"
import style0 from "./PayPalIntegration.vue?vue&type=style&index=0&id=db2f7076&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2f7076",
  null
  
)

export default component.exports